import { render, staticRenderFns } from "./EscalateQueryModal.vue?vue&type=template&id=8496f390&"
import script from "./EscalateQueryModal.vue?vue&type=script&lang=js&"
export * from "./EscalateQueryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports